import React from 'react';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { ContentLayout } from '@cloudscape-design/components';
import MessagesTable from './components/table';
import useInstanceSWR from '../../utils/hooks/useInstanceSWR';

export default function Messages() {
  const { data, isLoading, error } = useInstanceSWR('/messages', {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
  });

  return (
    <ContentLayout
      header={
        <Header
          variant='h1'
          description='Manage message group configuration for VOICE and OMNI'
        >
          Manage Groups
        </Header>
      }
    >
      <SpaceBetween size='m'>
        <MessagesTable
          isLoading={isLoading}
          error={error}
          messages={data?.data}
        />
      </SpaceBetween>
    </ContentLayout>
  );
}
